import { render, staticRenderFns } from "./validations.vue?vue&type=template&id=71f9330d"
import script from "./validations.vue?vue&type=script&lang=js"
export * from "./validations.vue?vue&type=script&lang=js"
import style0 from "./validations.vue?vue&type=style&index=0&id=71f9330d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports